import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@ui/shared/model';
import { isPropertyTaskRunning } from '../../utils/properties';

@Pipe({
  name: 'isPropertyTaskRunningPipe'
})
export class IsPropertyTaskRunningPipePipe implements PipeTransform {
  transform(property: Property): boolean {
    return isPropertyTaskRunning(property);
  }
}
